import React from 'react';
import { Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { type LaunchDarklyFlags, withLaunchDarkly } from '@/common/launchDarkly/launch-darkly';
import useUserInfo from '../../auth/useUserInfo';
import { FooterControls } from '../../components/senderBuild/footer-controls/footer-controls';
import { ResourceNames } from '../../lib/constants';
import { useIsMediumScreenMediaQuery, useIsSmallScreenMediaQuery } from '../../lib/isSmallScreen';
import * as actions from '../../store/senderBuild/actions';
import { BuilderExitBackButtons } from './builder-exit-back-buttons';
import { BuilderLayout } from './builder-layout';
import { useFetchEnvelopeInfoAndRecipients } from './use-fetch-envelope-info-and-recipients';
import { useSetDefaultZoom } from './use-set-default-zoom';

function TemplateBuilderPage(props: { flags: LaunchDarklyFlags }) {
  const { flags } = props;
  const { id: queryParamTemplateId } = useParams<{ id: string }>();

  const dispatch = useDispatch();
  const userInfo = useUserInfo();
  const isMdScreenOrSmaller = useIsMediumScreenMediaQuery();
  const isSmScreenOrSmaller = useIsSmallScreenMediaQuery();
  const history = useHistory();

  const setDefaultZoom = useSetDefaultZoom({ isSmallScreen: isSmScreenOrSmaller, isFullScreen: isMdScreenOrSmaller });
  useFetchEnvelopeInfoAndRecipients({
    envelopeId: queryParamTemplateId,
    resource: ResourceNames.TEMPLATE,
    setDefaultZoom,
    userInfo,
  });

  React.useEffect(() => {
    // Setting the initial state for the store state
    dispatch(actions.reset());
    // eslint-disable-next-line react-hooks/exhaustive-deps -- This code was written prior to enforcing lint rules
  }, []);

  return (
    <BuilderLayout
      flags={flags}
      footer={
        <FooterControls>
          <BuilderExitBackButtons flags={flags} />
          <Button variant="contained" color="primary" onClick={() => history.push('/templates')}>
            Save & Exit
          </Button>
        </FooterControls>
      }
    />
  );
}

const withLd = withLaunchDarkly(TemplateBuilderPage);
export { withLd as TemplateBuilderPage };
